// components/ReconnectModal.jsx: M4-7 minimal disconnect dialog.
//
// Per plan-m4 §M4-7: "You got disconnected" + room code + Rejoin button +
// Leave Room link. No animation, no countdown, no progress bar, the
// server-side 60s grace tick handles the timing.

/**
 * @param {{
 *   roomCode: string,
 *   onRejoin: () => void,
 *   onLeave:  () => void,
 * }} props
 */
export function ReconnectModal({ roomCode, onRejoin, onLeave }) {
  return (
    <div class="reconnect-modal cream" role="dialog" aria-modal="true" aria-labelledby="reconnect-modal-title">
      <div class="reconnect-modal__panel">
        <h2 id="reconnect-modal-title" class="reconnect-modal__title">You got disconnected</h2>
        <p class="reconnect-modal__room">Room <strong>{roomCode}</strong></p>
        <div class="reconnect-modal__actions">
          <button type="button" class="reconnect-modal__rejoin" onClick={onRejoin}>
            Rejoin
          </button>
          <button type="button" class="reconnect-modal__leave" onClick={onLeave}>
            Leave Room
          </button>
        </div>
      </div>
    </div>
  );
}
